import { platformHost } from "../../../../functions/platformHost";
import { useEffect, useRef, useState } from "react";
//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  requestTableRefresh,
  setChannelSearch,
  updateDatatableCheckColumn,
  updateFloatPanel,
} from "../../../../reducers/userConfigSlice";
//Components
import { Edition } from "./edition";
//Styles
import "./style.css";
import { LuStore, LuMonitorSmartphone, LuShoppingCart } from "react-icons/lu";
import { useChannelFacts, productsInCatalog, scheduleLabel, terminalCount, shippingLabel } from "./channelFacts";
import { CollectionSummary } from "../../../../components/collectionTools";
import { TableLayout } from "../../layouts/table";
import {
  deleteSalesChannelBatch,
  getSalesChannels,
  toggleChannelActiveStatus,
} from "../../../../api/salesChannels";

export const SalesChannel = () => {
  const dispatch = useDispatch();
  const facts = useChannelFacts();

  // =========== Datatable Configuration ============
  const sections = [
    {
      text: null,
      callback: () => null,
      actions: ["search", "select"],
      actionsWithSelect: [/*"clone",*/ "delete", "cancel"],
    },
  ];

  const customHeaders = {
    name: "Nombre",
    description: "Descripción",
    isActive: "Activar/Desactivar",
  };
  const customData = {
    isActive: (data, rowData) => <ChannelActive channel={rowData} />,
  };

  useEffect(() => {
    dispatch(setChannelSearch(""));
    dispatch(updateDatatableCheckColumn({ checkColumn: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="salesChannelReference"><TableLayout
      showLayoutToggle={false}
      title="Canal de venta"
      renderCards={(rows, edit) => <ChannelCards rows={rows} edit={edit} facts={facts} />}
      renderSummary={(rows) => (
        <CollectionSummary
          items={[
            { label: "Canales activos", value: rows.filter(row => row.isActive === true || row.isActive === 1).length, icon: <LuStore /> },
            { label: "Pedidos en mostrador", value: <span title="No hay un desglose de pedidos por tipo de canal disponible" aria-label="Pedidos en mostrador: sin desglose disponible">—</span>, icon: <LuMonitorSmartphone /> },
            { label: "Pedidos online", value: <span title="No hay un desglose de pedidos por tipo de canal disponible" aria-label="Pedidos online: sin desglose disponible">—</span>, icon: <LuShoppingCart /> },
          ]}
        />
      )}
      addText="Crear canal de venta"
      edition={<Edition />}
      get={getSalesChannels}
      toogle={() => null}
      remove={deleteSalesChannelBatch}
      sections={sections}
      customHeaders={customHeaders}
      customData={customData}
      identificator={"salesChannel"}
      idKey={"salesChannelId"}
    />{facts.error && <p className="channelFactsError" role="alert">No se han podido cargar algunos datos de los canales. <button type="button" onClick={facts.retry}>Reintentar datos</button></p>}</div>
  );
};

export const ChannelActive = ({ channel }) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(
    channel.isActive === true || channel.isActive === 1,
  );
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false);
  useEffect(
    () => setActive(channel.isActive === true || channel.isActive === 1),
    [channel.isActive],
  );
  const toggle = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      const response = await toggleChannelActiveStatus(channel.salesChannelId);
      if (response?.error !== false) throw new Error();
      setActive((previous) => !previous);
      dispatch(requestTableRefresh());
    } catch {
      setError("No se pudo cambiar el estado. Vuelve a intentarlo.");
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  return (
    <div className="channelActive" aria-busy={busy}>
      <button
        type="button"
        role="switch"
        aria-label={`Canal activo: ${channel.name}`}
        aria-checked={active}
        disabled={busy}
        onClick={toggle}
      >
        <span aria-hidden="true" />
        {busy ? "Guardando…" : active ? "Activo" : "Inactivo"}
      </button>
      {error && <p role="alert">{error}</p>}
    </div>
  );
};
export const ChannelCards = ({ rows, edit, facts }) => {
  const dispatch = useDispatch();
  const subdomain = useSelector(state => state.aplicationConfig.corporationData?.corporationOwner?.corporationData?.subdomain);
  const search = useSelector(state => state.aplicationConfig.userConfig?.channelSearch || "");
  const visible = rows.filter(row => `${row.name || ""} ${row.description || ""}`.toLocaleLowerCase().includes(search.toLocaleLowerCase()));
  return <section className="channelCardsView" aria-label="Canales de venta">
    <label className="channelSearch channelMobileSearch"><span className="visually-hidden">Buscar en canal de venta</span><input type="search" aria-label="Buscar canales en móvil" placeholder="Buscar en canal de venta…" value={search} onChange={event=>dispatch(setChannelSearch(event.target.value))} /></label>
    <div className="channelCards">{visible.map(row => {
      const terminals = terminalCount(row, facts.points);
      const active = row.isActive === true || row.isActive === 1;
      const products = productsInCatalog(row, facts.products);
      const schedule = scheduleLabel(row, facts.hours);
      return <article className="channelCard" key={row.salesChannelId}>
        <header className="channelCardHeading"><span className="channelCardIcon" aria-hidden="true">{row.type === "ONLINE" ? <LuShoppingCart /> : <LuMonitorSmartphone />}</span><h2>{row.name}</h2><span className={`channelStatus ${active ? "channelStatusActive" : ""}`}>{active ? "Activo" : "Inactivo"}</span></header>
        <p><strong>{row.type === "ONLINE" ? "Venta online · Shop" : "TPV · Mostrador"}</strong>{row.description ? ` · ${row.description}` : ""}</p>
        {row.type !== "ONLINE" && !row.configurationEnabled && <p className="channelHelp">Guarda el canal para aplicar su catálogo y variación de precio a las nuevas ventas.</p>}
        <dl className="channelFacts">
          <div><dt>Catálogo</dt><dd title={row.Catalog?.name}>{row.Catalog?.name || "Sin catálogo asignado"}</dd></div><div><dt>Variación de precio</dt><dd>{row.pricePercentage ?? 0} %</dd></div>
          <div><dt>Productos</dt><dd title="Productos publicados y activos del catálogo asignado">{products == null ? "Sin datos disponibles" : `${products} productos`}</dd></div>
          <div><dt>Horario</dt><dd title={schedule.detail}>{schedule.text}</dd></div>
          <div><dt>Pago</dt><dd title={row.paymentMethods?.map(item => item.name).join(" · ")}>{row.paymentMethods?.map(item => item.name).join(" · ") || "Sin métodos asignados"}</dd></div>
          <div><dt>Entrega</dt><dd title={shippingLabel(row, facts.shipping)}>{shippingLabel(row, facts.shipping)}</dd></div>
          {row.type !== "ONLINE" && terminals > 0 && <><div><dt>Terminales</dt><dd>{terminals}</dd></div><div><dt>Caja</dt><dd>Sin estado disponible</dd></div></>}
        </dl>
        <footer className="channelCardFooter"><ChannelActive channel={row} />{subdomain && <a href={`https://${platformHost(subdomain, row.type === "ONLINE" ? "shop" : "tpv")}`} target="_blank" rel="noreferrer">{row.type === "ONLINE" ? "Abrir Shop" : "Abrir TPV"}</a>}<button type="button" className="channelConfigure" aria-label={`Configurar ${row.name}`} onClick={() => edit(row)}>Configurar</button></footer>
      </article>;
    })}{!rows.some(row => row.type === "ONLINE") && (!search || "venta online shop".includes(search.toLocaleLowerCase())) && <article className="channelCard">
      <header className="channelCardHeading"><span className="channelCardIcon" aria-hidden="true"><LuShoppingCart /></span><h2>Venta online</h2><span className="channelStatus">Sin configurar</span></header>
      <p>Configura el canal de la Shop: catálogo, métodos de pago y entrega y variación de precio.</p>
      <p className="channelHelp">La tienda conserva su configuración actual hasta que guardes este canal.</p>
      <footer className="channelCardFooter"><button type="button" className="channelConfigure" onClick={() => dispatch(updateFloatPanel({ visible: true, isEmpty: true, queryId: null, data: { type: "ONLINE", name: "Venta online", identifier: "venta-online" } }))}>Configurar Venta online</button></footer>
    </article>}</div>
    {!visible.length && rows.some(row => row.type === "ONLINE") && <p role="status">No hay canales que coincidan. Cambia la búsqueda para volver a verlos.</p>}
  </section>;
};
